import React from "react";
const icon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.5504 9.07837C28.4878 8.77218 27.3814 9.3908 27.0752 10.4531L19.0745 38.4472C18.7683 39.5094 19.3871 40.6155 20.4496 40.9216C21.5122 41.2278 22.6186 40.6092 22.9248 39.5469L30.9255 11.5528C31.2317 10.4906 30.6129 9.38455 29.5504 9.07837V9.07837ZM34.5883 16.583C33.8069 17.3641 33.8069 18.6326 34.5883 19.4137L40.1699 25L34.582 30.5863C33.8007 31.3674 33.8007 32.6359 34.582 33.417C35.3633 34.1981 36.6322 34.1981 37.4135 33.417L44.414 26.4185C45.1953 25.6374 45.1953 24.3689 44.414 23.5878L37.4135 16.5893C36.6322 15.8082 35.3633 15.8082 34.582 16.5893L34.5883 16.583ZM15.418 16.583C14.6367 15.8019 13.3678 15.8019 12.5865 16.583L5.58598 23.5816C4.80467 24.3626 4.80467 25.6311 5.58598 26.4122L12.5865 33.4107C13.3678 34.1918 14.6367 34.1918 15.418 33.4107C16.1993 32.6296 16.1993 31.3612 15.418 30.5801L9.83007 25L15.418 19.4137C16.1993 18.6326 16.1993 17.3641 15.418 16.583Z"
      fill="#8F04E8"
    />
  </svg>
);

export default icon;
